export default "__VITE_ASSET__DptZwA5u__"